import React from 'react';
import { Typography, Button, Paper, Alert } from '@mui/material';
import TableView from './TableView';

const FREE_PLAN_ID = 1;

const ContractList = ({ contracts = [], onDeleteAccount }) => {
    if (!contracts.length) {
        return <Typography>現在有効な契約はありません。</Typography>;
    }

    const hasFreePlan = contracts.some(c => Number(c.plan_id) === FREE_PLAN_ID);

    const columns = [
        {
            label: 'プラン名',
            accessor: 'plan_name',
        },
        {
            label: '説明',
            accessor: 'description', // 契約ステータスなど必要に応じて
        },
        {
            label: '開始日',
            accessor: 'start_date',
            format: (val) => val?.slice(0, 10) || '-',
        },
    ];

    return (
        <Paper variant='section'>
            <Typography component='h2' variant="h4" sx={{ mb: 2 }}>
                ご契約状況
            </Typography>
            {/* テーブル表示 */}
            <TableView
                dataset={contracts}
                columns={columns}
                keyColumn="contract_id"
            />
            {hasFreePlan && (
                <Button
                    variant="outlined"
                    color="error"
                    sx={{ mt: 2 }}
                    onClick={() => {
                        const freeContract = contracts.find(c => Number(c.plan_id) === FREE_PLAN_ID);
                        onDeleteAccount(freeContract);
                    }}
                >
                    アカウントを削除
                </Button>
            )}
            {contracts.some(c => Number(c.plan_id) !== FREE_PLAN_ID) && (
                <Alert severity="info" sx={{ mt: 2 }}>
                    プラン変更は担当営業へご連絡ください。
                </Alert>
            )}
        </Paper>
    );
};

export default ContractList;
